import { verticalKnot } from 'src/features/gorilla/drawer/common/back/lace/webKnots'
import { tiedLittleMachiMaterialSide, tiedLittleMachiMaterialDiagonal } from './tiedLittleMachi'
import { webKnotDownward, webKnotUpward } from 'src/features/gorilla/drawer/common/back/lace/webKnotSingle'
import {
  arroundEdge1,
  arroundEdge2,
  arroundEdge3,
  arroundEdge7,
  arroundEdge9,
  arroundEdge10,
  arroundEdge11,
  arroundEdge12,
  arroundEdge13
} from './arroundEdge'

export const laceDrawer = (ctx: CanvasRenderingContext2D, color: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = 'red' // '#383838'
  ctx.fillStyle = color

  webKnotDownward(ctx, color, -560, 211, 0, 0.8) // 小指掛け紐の右下
  webKnotDownward(ctx, color, -588, 150, 0, 0.8) // 小指掛け紐の左上

  tiedLittleMachiMaterialSide(ctx, color, 0, 0)
  tiedLittleMachiMaterialSide(ctx, color, 70, -10)
  tiedLittleMachiMaterialDiagonal(ctx, color, 0, 0)
  tiedLittleMachiMaterialDiagonal(ctx, color, -130, 85, -20, 1.1)
  tiedLittleMachiMaterialDiagonal(ctx, color, -47, 140, -35, 1.2)

  // 捕球面＿真下＿右
  arroundEdge1(ctx, color, 0, 0)
  arroundEdge1(ctx, color, 33, 18)
  arroundEdge2(ctx, color)
  arroundEdge3(ctx, color, 0, 0, 0)

  // 捕球面＿真下＿左
  arroundEdge7(ctx, color, 0, 0, 0)
  arroundEdge7(ctx, color, 48, -195, 20)
  arroundEdge7(ctx, color, 17, -234, 20)
  arroundEdge7(ctx, color, -15, -430, 40)
  arroundEdge9(ctx, color, 0, 0)
  arroundEdge9(ctx, color, -17, -12)
  arroundEdge10(ctx, color, 68, -253, 35)
  arroundEdge10(ctx, color, 53, -200, 30)
  arroundEdge10(ctx, color, 43, -65, 10)
  arroundEdge10(ctx, color, 0, 0, 0)
  arroundEdge10(ctx, color, -38, 13, 0)
  arroundEdge11(ctx, color, 77, -200, 40, 0.9)
  arroundEdge11(ctx, color, 0, 0, 0, 1)
  arroundEdge11(ctx, color, -70, 47, -11, 1.1)
  arroundEdge11(ctx, color, -144, 93, -24, 1.1)
  arroundEdge12(ctx, color, 0, 0, 0, 1)
  arroundEdge12(ctx, color, -5, 45, 0, 1)
  arroundEdge12(ctx, color, -53, 100, -8, 1)
  arroundEdge12(ctx, color, -160, 150, -23, 1)
  arroundEdge13(ctx, color, 0, 0)
  arroundEdge13(ctx, color, 20, 16)

  verticalKnot(ctx, color, 0, 0, 1)

  webKnotDownward(ctx, color, 365, -150, 20, 0.7) //親指袋の先端
  webKnotUpward(ctx, color, 130, -220, 20)
}
